import * as yup from 'yup';

const Step1Module1Schema = yup.object().shape({
  operationType: yup.string().required(),
  propertyType: yup.string().required(),
  propertySubType: yup
    .string()
    .when('$validateSubType', (validateSubType, schema) => (validateSubType ? schema.required() : schema))
});

export { Step1Module1Schema };
